import { render, staticRenderFns } from "./languageModal.vue?vue&type=template&id=327c5587&lang=pug&"
import script from "./languageModal.vue?vue&type=script&lang=js&"
export * from "./languageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports